import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upcoming-part',
  templateUrl: './upcoming-part.component.html',
  styleUrls: ['./upcoming-part.component.css']
})
export class UpcomingPartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
